import { render, staticRenderFns } from "./TaxesViewTable.vue?vue&type=template&id=3448e2ca&scoped=true&"
import script from "./TaxesViewTable.vue?vue&type=script&lang=js&"
export * from "./TaxesViewTable.vue?vue&type=script&lang=js&"
import style0 from "./TaxesViewTable.vue?vue&type=style&index=0&id=3448e2ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3448e2ca",
  null
  
)

export default component.exports